<script lang="ts">
  import {
    createPopper,
    type Instance as Popper,
    type Options as PopperOptions,
  } from "@popperjs/core";

  import { tooltipLabels } from "../lang";
  import Icon from "./Icon.svelte";

  export let label: string;
  export let text: string;

  const id = crypto.randomUUID();

  let trigger: HTMLButtonElement = null;
  let popup: HTMLSpanElement = null;
  let popper: Popper = null;
  let open = false;

  const modifiers: PopperOptions["modifiers"] = [
    {
      name: "offset",
      options: {
        offset: [0, 8],
      },
    },
    {
      name: "preventOverflow",
      options: {
        padding: 8,
      },
    },
  ];

  function openDialog() {
    open = true;
    popper = createPopper(trigger, popup, { modifiers });
  }

  function closeDialog() {
    open = false;
    popper.destroy();
  }

  function toggleDialog() {
    if (open) {
      closeDialog();
    } else {
      openDialog();
    }
  }
</script>

<button
  class="Tooltip-trigger"
  aria-label={label}
  aria-describedby={id}
  on:click={toggleDialog}
  bind:this={trigger}
>
  <Icon type="info" />
</button>

<span
  {id}
  class="Tooltip-popup"
  role="tooltip"
  bind:this={popup}
  hidden={!open}
>
  <button
    class="Tooltip-close"
    aria-label={tooltipLabels.close}
    on:click={closeDialog}
  >
    <Icon type="close" />
  </button>

  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html text}
</span>

<style>
  .Tooltip-trigger {
    display: inline-flex;
    font-size: 1em;
  }

  .Tooltip-popup {
    background: var(--color-white);
    border: var(--size-1) solid var(--color-gray-border);
    border-radius: var(--size-4);
    box-shadow: 0 2px 10px hsl(0 0% 0% / 0.2);
    font-family: var(--font-family-default);
    font-size: var(--size-13);
    font-weight: normal;
    hyphens: auto;
    inline-size: 13rem;
    line-height: 1.3;
    padding-block: var(--size-10);
    padding-inline: var(--size-10) var(--size-22);
    text-align: start;
    text-wrap: balance;
    z-index: 1;
  }

  .Tooltip-close {
    display: flex;
    font-size: var(--size-15);
    inset-block-start: var(--size-4);
    inset-inline-end: var(--size-4);
    position: absolute;
  }
</style>
